<template>
  <DefaultLayout :withHeader="true" :withFooter="true">
    <div class="container">
      <StandardHero
          :title="$t('banner.about.title')"
          description=""
          backgroundImage="Thessaloniki_06.jpg"
          textBackgroundColor="#4eedfe"
          text-align="right"
      />
      <h1>{{ $t('about.title') }}</h1>
      <p>{{ $t('about.description') }}</p>
    </div>
    <ContactSectionNew />
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '@/layout/DefaultLayout.vue';
import StandardHero from "@/components/StandardHero.vue";
import ContactSectionNew from "@/components/ContactSectionNew.vue";

export default {
  components: {
    ContactSectionNew,
    StandardHero,
    DefaultLayout,
  },
};
</script>

<style scoped>
  #standard-hero {
    h1 {
      padding: 100px 0;
      background: #4eedfe;
    }
  }
</style>

